export default "__VITE_ASSET__Bnsq7FMN__"